/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { Task } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import AuthService from 'cio/services/auth';
import { inject as service } from '@ember/service';
import CampaignModel from 'cio/models/campaign';

interface FormsFacebookLeadAdsDisconnectPageConfirmModalArgs {
  onClose: () => unknown;
  submitTask: Task<unknown, []>;
  formsCount: number;
  campaigns: CampaignModel[];
  facebookPageName: string;
}

export default class FormsFacebookLeadAdsDisconnectPageConfirmModal extends Component<FormsFacebookLeadAdsDisconnectPageConfirmModalArgs> {
  @service auth!: AuthService;

  @tracked enteredFacebookPageName = '';

  get isSubmitDisabled() {
    return (
      !this.auth.hasPermission('journeys/forms/delete') ||
      this.args.submitTask.isRunning ||
      this.enteredFacebookPageName !== this.args.facebookPageName
    );
  }
}
